import React from 'react'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import ModalTitle from 'app/components/Modal/ModalTitle'
import ModalBody from 'app/components/Modal/ModalBody'
import ModalContent from 'app/components/Modal/ModalContent'
import AvailableDomain from 'app/components/SVGS/AvailableDomain'
import TableSimple from 'app/domains/common/AdminAndSuperAdminComponents/BulkManagement/TableSimple'

import './styles.scss'
import { IBulkManagementPopupProps, IManagedUser } from './interface'

const bc = 'manage-protracklevels-popup'

const BulkManagementPopup: React.FC<IBulkManagementPopupProps> = ({
  onRequestClose,
  data,
  t,
  title,
  subtitle,
  titleFirstTable,
  titleSecondTable,
}) => {
  const { successful, failed, successfulCount, failedCount } = data
  return (
    <ModalBody onRequestClose={onRequestClose}>
      <ModalTitle className={`${bc}__common`}>{title}!</ModalTitle>
      <ModalContent className={`${bc}__common`}>
        <span
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      </ModalContent>

      {successfulCount ? (
        <React.Fragment>
          <ModalContent className={cn(`${bc}__successful`, `${bc}__common`)}>
            <AvailableDomain />
            <span style={{ marginLeft: '8px' }}>{titleFirstTable}:</span>
          </ModalContent>
          <ModalContent className={`${bc}__common`}>
            <TableSimple
              headers={[t('common:Email')]}
              bodyClassName={`${bc}__table-body`}
              data={successful}
              renderBody={(successful: string[]) =>
                successful.map((userEmail: string) => (
                  <tr key={userEmail}>
                    <td>{userEmail}</td>
                  </tr>
                ))
              }
            />
          </ModalContent>
        </React.Fragment>
      ) : null}

      {failedCount ? (
        <React.Fragment>
          <ModalContent className={cn(`${bc}__failed`, `${bc}__common`)}>
            <AvailableDomain />
            <span style={{ marginLeft: '8px' }}>{titleSecondTable}:</span>
          </ModalContent>
          <ModalContent className={`${bc}__common`}>
            <TableSimple
              headers={[t('common:Email'), t('admin:Reason')]}
              bodyClassName={`${bc}__table-body`}
              data={failed}
              renderBody={(failed: IManagedUser[]) =>
                failed.map((user: IManagedUser) => (
                  <tr key={user.email}>
                    <td>{user.email}</td>
                    <td>{t(`common:${user.reason}`)}</td>
                  </tr>
                ))
              }
            />
          </ModalContent>
        </React.Fragment>
      ) : null}
    </ModalBody>
  )
}

export default withTranslation()(BulkManagementPopup)
